module.exports = __webpack_public_path__ + "static/media/view1.3a236a2c.jpg";